import { Link } from "react-router-dom";
import { leagues } from "@/mocks/leagues";
import { matches } from "@/mocks/matches";

export default function LeagueEntries() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="mb-6">
        <span className="font-label text-xs tracking-[0.3em] text-accent-600 uppercase">
          Leagues
        </span>
        <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950 mt-1">
          热门赛事联赛
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {leagues.map((l) => {
          const count = matches.filter((m) => m.leagueSlug === l.slug).length;
          return (
            <Link
              key={l.slug}
              to={`/category/${l.slug}`}
              className="group relative overflow-hidden rounded-lg border border-background-200 cursor-pointer"
            >
              <img
                src={l.banner}
                alt={`${l.fullName} 赛事直播`}
                title={`${l.name} 篮球直播与赛程 - 篮球直播`}
                className="w-full h-56 object-top object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/50 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="w-2 h-2 rounded-full" style={{ backgroundColor: l.accent }} />
                  <span className="text-[11px] font-label text-accent-400 tracking-wide">
                    {l.region}
                  </span>
                </div>
                <h3 className="font-heading font-semibold text-xl text-background-50">{l.name}</h3>
                <p className="mt-1 text-xs text-primary-200 line-clamp-2">{l.fullName}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-[11px] text-primary-300">共 {count} 场赛事</span>
                  <span className="inline-flex items-center gap-1 text-xs text-background-50 group-hover:text-accent-400 transition-colors">
                    进入分类
                    <i className="ri-arrow-right-s-line" />
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}